"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonFunctions = void 0;
const constants_1 = require("./constants");
const CryptoJS = __importStar(require("crypto-js"));
const nodejs_library_1 = require("@tpd-web-common-libs/nodejs-library");
class CommonFunctions {
    static encryptBFFRequest(cfCliente) {
        const timeStamp = new Date().toISOString();
        const encryptionType = constants_1.Constants.encrypt.encType;
        const pipe = constants_1.Constants.encrypt.encPipe;
        const obj = JSON.stringify({ cfpiva: cfCliente, ts: timeStamp });
        const token = CryptoJS.HmacSHA256(encryptionType + pipe + obj, constants_1.Constants.vendor.core).toString();
        return "".concat(encryptionType, pipe, obj, pipe, token).toString(); // ES: 1|{"cfpiva":"SLDVVN75D59H501T","ts":"2018-09-19T13:30:56.565Z"}|15b542201de4847890eb83de6189aadd5faed6a5e3fef21ca37fbfa12ec23d85
    }
    static isUserLogged() {
        return nodejs_library_1.Helpers.SessionHelper.getData("_isLogged")
            .then((res) => !!res)
            .catch(() => false);
    }
    static isUtenteUnipolMove() {
        return nodejs_library_1.Helpers.SessionHelper.getData("_isUtenteUnipolMove")
            .then((res) => !!res)
            .catch(() => false);
    }
    static downloadPDF(response, titolo) {
        const blob = response.body;
        const fileName = (titolo ? titolo : "Documento") + ".pdf";
        if (typeof window === "object" && typeof document === "object") {
            const a = document.createElement("a");
            a.setAttribute("href", window.URL.createObjectURL(blob));
            a.setAttribute("download", fileName);
            a.setAttribute("target", "_blank");
            const clickEvent = document.createEvent("MouseEvent");
            clickEvent.initMouseEvent("click", true, true, window, 0, clickEvent.screenX, clickEvent.screenY, clickEvent.clientX, clickEvent.clientY, clickEvent.ctrlKey, clickEvent.altKey, clickEvent.shiftKey, clickEvent.metaKey, 0, null);
            // dispatch click event to simulate download
            a.dispatchEvent(clickEvent);
            try {
                document.body.removeChild(a);
            }
            catch (e) {
                /* empty */
            }
        }
    }
    static getParameterByName(name, decoding = true) {
        const url = window.location.href;
        name = name.replace(/[\[\]]/g, '\\$&');
        const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'), results = regex.exec(url);
        if (!results) {
            return null;
        }
        if (!results[2]) {
            return '';
        }
        let decoded = results[2];
        if (decoding) {
            decoded = decodeURIComponent(results[2]).replace(/ /g, '+');
        }
        return decoded;
    }
    static selectiveStorageClear() {
        const localStorageToRemove = [];
        for (const itemToRemove in constants_1.Constants.lsMapObject) {
            if (itemToRemove) {
                localStorageToRemove.push(itemToRemove);
            }
        }
        const sessionStorageToRemove = [
            'analytics',
            constants_1.Constants.networkConfigSessionStorageParameter,
            constants_1.Constants.uniqueElencoNotifiche,
            constants_1.Constants.sl,
            constants_1.Constants.myReportsResponse,
            constants_1.Constants.sentAnalyticsRenewal,
            'user_crm_id'
        ];
        for (const sessionStorageItem of sessionStorageToRemove) {
            if (sessionStorage.getItem(sessionStorageItem)) {
                sessionStorage.removeItem(sessionStorageItem);
            }
        }
        for (const localStorageItem of localStorageToRemove) {
            if (localStorage.getItem(localStorageItem)) {
                localStorage.removeItem(localStorageItem);
            }
        }
    }
    static base64ToBlob(base64, mimeType) {
        const byteArray = Buffer.from(base64, 'base64');
        return new Blob([byteArray], { type: mimeType });
    }
}
exports.CommonFunctions = CommonFunctions;
